module.exports = __webpack_public_path__ + "static/img/8.bc38a0e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/sp/8.png
// module id = +hsa
// module chunks = 0